import React, { useState } from 'react';
import {
  ICustomer,
  ECustomerBlockType,
  IBlock
} from '../../../../../../store/ducks/customers/types';
import { Container } from './styles';

interface CustomerBlockModalContentProps {
  customer: ICustomer;
}

const CustomerBlockModalContent: React.FC<CustomerBlockModalContentProps> = ({
  customer
}) => {
  const getBlockMessage = (): string => {
    if (!customer.blocks || !customer.blocks.length) {
      return ' - ';
    }

    const block = customer.blocks[0] as IBlock;
    switch (block.type) {
      case ECustomerBlockType.LIMITE_CREDITO_EXCEDIDO:
        return `atingiu o valor de crédito limite. Entre em contato com seu vendedor para regularizar a situação. 
                    Para continuar comprando, clique na opção Pagamento antecipado.`;

      case ECustomerBlockType.LIMITE_CREDITO_EXPIRADO:
        return `teve o limite de crédito expirado. Entre em contato com seu vendedor para regularizar a situação. 
                    Para continuar comprando, clique na opção Pagamento antecipado.`;

      case ECustomerBlockType.PARTIDAS_VENCIDAS:
        return `possui faturas vencidas. Para visualizá-las, acesse a sessão Minhas Finanças. 
                    Maiores dúvidas entre em contato com o seu vendedor.`;

      case ECustomerBlockType.CLIENTE_INATIVO:
      case ECustomerBlockType.PERIGO_OU_FRAUDE:
      case ECustomerBlockType.FALENCIA_CONCORDATA:
      case ECustomerBlockType.BLOQUEIO_AREA_COBRANCA:
      case ECustomerBlockType.BLOQUEIO_AREA_JURIDICA:
      case ECustomerBlockType.PROTESTOS:
      case ECustomerBlockType.CHEQUE_DEVOLVIDO:
      case ECustomerBlockType.NOVACAO_DIVIDA:
      case ECustomerBlockType.LUCROS_PERDAS_PDD:
      case ECustomerBlockType.PRELIMINAR:
      case ECustomerBlockType.JOB_COMPLETO:
      case ECustomerBlockType.RECUPERACAO_JUDICIAL:
      case ECustomerBlockType.TRADEMASTER:
      case ECustomerBlockType.ACORDO_VERBAL:
      case ECustomerBlockType.PAGAMENTO_CAMPANHA:
      case ECustomerBlockType.SHIPPING:
      case ECustomerBlockType.BILLING:
      case ECustomerBlockType.ORDER:
      default:
        return `está com o cadastro bloqueado. Entre em contato com seu vendedor para verificar a situação. 
                    Para continuar comprando, clique na opção Pagamento antecipado.`;
    }
  };

  const [message] = useState(getBlockMessage());

  return (
    <Container>
      <p>
        O emissor selecionado{' '}
        <strong>{`${customer.name} ${
          customer.taxNumber ? ' - CNPJ ' + customer.taxNumber : ''
        } `}</strong>
        {message}
      </p>
    </Container>
  );
};

export default CustomerBlockModalContent;
